/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeePayDetailsWithBatchSummary } from './EmployeePayDetailsWithBatchSummary';
import {
    EmployeePayDetailsWithBatchSummaryFromJSON,
    EmployeePayDetailsWithBatchSummaryFromJSONTyped,
    EmployeePayDetailsWithBatchSummaryToJSON,
    EmployeePayDetailsWithBatchSummaryToJSONTyped,
} from './EmployeePayDetailsWithBatchSummary';

/**
 * 
 * @export
 * @interface UpdateEmployeePayDetailResponse
 */
export interface UpdateEmployeePayDetailResponse {
    /**
     * 
     * @type {EmployeePayDetailsWithBatchSummary}
     * @memberof UpdateEmployeePayDetailResponse
     */
    data: EmployeePayDetailsWithBatchSummary;
}

/**
 * Check if a given object implements the UpdateEmployeePayDetailResponse interface.
 */
export function instanceOfUpdateEmployeePayDetailResponse(value: object): value is UpdateEmployeePayDetailResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateEmployeePayDetailResponseFromJSON(json: any): UpdateEmployeePayDetailResponse {
    return UpdateEmployeePayDetailResponseFromJSONTyped(json, false);
}

export function UpdateEmployeePayDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmployeePayDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeePayDetailsWithBatchSummaryFromJSON(json['data']),
    };
}

  export function UpdateEmployeePayDetailResponseToJSON(json: any): UpdateEmployeePayDetailResponse {
      return UpdateEmployeePayDetailResponseToJSONTyped(json, false);
  }

  export function UpdateEmployeePayDetailResponseToJSONTyped(value?: UpdateEmployeePayDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeePayDetailsWithBatchSummaryToJSON(value['data']),
    };
}

